import { CircularProgress } from '@mui/material';
import { getObjectListByPropertyApi } from 'api/general';
import PendingAgendaDataTable from 'app/components/DataTable/agenda/PendingAgendaDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import { DECISION } from 'app/utils/constants/customConstant';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const PendingAgendasPage = () => {


    const [loading, setLoading] = useState(false);
    const [agendaList, setAgendaList] = useState([]);
    const allAuthorizedUnits = useSelector(state => state.auth.allAuthorizedUnits);

    const tableCellStyle = { fontSize: '12px' };
    const commonColumnStyle = { ...tableCellStyle, minWidth: 45, maxWidth: 45 };

    const columnData = [

        { id: 'department', align: 'left', disablePadding: false, label: "İlgili Kurum/Birim", sx: commonColumnStyle },
        { id: 'subject', align: 'left', disablePadding: false, label: "Konu", sx: { ...tableCellStyle, maxWidth: 50 } },
        { id: 'agenda', align: 'left', disablePadding: false, label: "Gündem", sx: { ...tableCellStyle, minWidth: 150, maxWidth: 170 } },
        { id: 'decision', align: 'left', disablePadding: false, label: "Karar", sx: { ...tableCellStyle, minWidth: 150, maxWidth: 170 } },
        { id: 'islemler', align: 'center', disablePadding: false, label: "İşlemler", sx: { ...tableCellStyle, minWidth: 80, maxWidth: 100 } }
    ];

    useEffect(() => {
        const getAPI = async () => {
            setLoading(true);
            try {

                let agendas = [];

                agendas = await getObjectListByPropertyApi(DECISION, "meetingId", "-1");
                agendas = agendas.data;
                agendas = agendas.filter(agenda => agenda.pendingUnitId !== 0);
                agendas = agendas.filter(agenda => allAuthorizedUnits.includes(agenda.pendingUnitId));

                setAgendaList(agendas);
            } catch (error) {
                console.error("API Hatası: ", error);
            } finally {
                setLoading(false);
            }
        };

        getAPI();
    }, []);


    return (
        <React.Fragment>

            <>
                <LoadingPopUp open={loading} />
                {!loading && <PendingAgendaDataTable mainData={agendaList} column={columnData} />}
            </>
        </React.Fragment>
    );
};

export default PendingAgendasPage;